module.exports = __webpack_public_path__ + "img/Rosa.6de1783f.jpg";